const toRgbParts = colorValue => {
  const [r, g, b, a] = colorValue.replace('rgba(', '').replace(')', '').split(',').map(value => parseFloat(value.trim()));
  const rgbValues = [r, g, b];
  const rgbString = rgbValues.join(',');
  if (a === 1) {
    return {
      full: rgbString,
      rgb: rgbString,
      opacity: 1
    };
  }
  return {
    full: [...rgbValues, a].join(','),
    rgb: rgbString,
    opacity: a
  };
};
export const getColorCssVars = (key, colorValue) => {
  if (!colorValue) {
    return {};
  }
  const rgbParts = toRgbParts(colorValue);
  return {
    [key]: rgbParts.full,
    [`${key}-rgb`]: rgbParts.rgb,
    [`${key}-opacity`]: rgbParts.opacity
  };
};
//# sourceMappingURL=getColorCssVars.js.map